import { selfInstantiateOnLoad } from "../utils";
const incentiveTypesAttribute = "data-incentive-types";
const incentiveModelAttribute = "data-incentive-model";
const incentiveCategoryAttribute = "data-incentive-category";
const typeFilterAttribute = "data-filter-type";
const modelFilterAttribute = "data-filter-model";
const categoryFilterAttribute = "data-filter-category";
const fuelTypeAttribute = "data-fuel-type";
const groupTitleSelector = ".rtimodeltitle";
const categoryTitleSelector = ".rtiCategoryTitle";
const incentiveBlockSelector = ".rtifilter";
const noResultsSelector = "#rtiNoResults";
export default class ManufacturerIncentives {
    get _categoryHeaders() {
        return document.querySelectorAll(categoryTitleSelector);
    }
    get _groupHeaders() {
        return document.querySelectorAll(groupTitleSelector);
    }
    get _incentiveBlocks() {
        return document.querySelectorAll(incentiveBlockSelector);
    }
    get _noResultsMessage() {
        return document.querySelector(noResultsSelector);
    }
    constructor() {
        this._selectedTypeFilter = "all";
        this._selectedModelFilter = "all";
        this._selectedCategoryFilter = "all";
        this._typeFilterElements = {};
        this._modelFilterElements = {};
        this._categoryFilterElements = {};
        this._NewSubaruIncentivesPage = false;
        this.addEventListeners();
        this.filterIncentivesByHash();
        // Release Toggle utilized for the filters
        this._NewSubaruIncentivesPage =
            document
                .getElementById("content-main-incentives")
                ?.getAttribute("new-subaru-incentives-page") === "true";
    }
    addEventListeners() {
        document.addEventListener("click", (e) => {
            const target = e.target;
            const typeFilter = target.closest(`[${typeFilterAttribute}]`);
            if (typeFilter) {
                const filter = typeFilter.getAttribute(typeFilterAttribute);
                this._typeFilterElements[filter] = typeFilter;
                this.filterIncentivesByType(filter);
                if (this._NewSubaruIncentivesPage) {
                    this.updateDropdownButtonText("dropdownMenuTypes", typeFilter, null);
                }
                return;
            }
            const modelFilter = target.closest(`[${modelFilterAttribute}]`);
            if (modelFilter) {
                const filter = modelFilter.getAttribute(modelFilterAttribute);
                this._modelFilterElements[filter] = modelFilter;
                this.filterIncentivesByModel(filter);
                if (this._NewSubaruIncentivesPage) {
                    this.updateDropdownButtonText("dropdownMenu1", modelFilter, "DefaultRtiFilterLabel");
                }
                return;
            }
            const categoryFilter = target.closest(`[${categoryFilterAttribute}]`);
            if (categoryFilter) {
                const filter = categoryFilter.getAttribute(categoryFilterAttribute);
                this._categoryFilterElements[filter] = categoryFilter;
                this.filterIncentivesByCategory(filter);
                if (this._NewSubaruIncentivesPage) {
                    this.updateDropdownButtonText("dropdownMenuCategories", categoryFilter, null);
                }
            }
        });
    }
    updateDropdownButtonText(dropdownMenuId, selectedItem, defaultLabelId) {
        const dropdownMenu = document.getElementById(dropdownMenuId);
        if (!dropdownMenu)
            return;
        const selectedText = selectedItem.querySelector("a")?.textContent?.trim() ?? "";
        const defaultLabel = defaultLabelId
            ? document.getElementById(defaultLabelId)?.value ??
                selectedText
            : selectedText;
        const isAll = selectedItem.getAttribute(modelFilterAttribute) === "all" ||
            selectedItem.getAttribute(categoryFilterAttribute) === "all";
        const displayText = isAll ? defaultLabel : selectedText;
        const caret = dropdownMenu.querySelector(".caret");
        dropdownMenu.textContent = displayText + " ";
        if (caret) {
            dropdownMenu.appendChild(caret);
        }
        else {
            const newCaret = document.createElement("span");
            newCaret.className = "caret";
            dropdownMenu.appendChild(newCaret);
        }
    }
    filterIncentivesByHash() {
        const { type, model } = ManufacturerIncentives.getFiltersFromUrl();
        document
            .querySelector(`[${typeFilterAttribute}="${type}"]`)
            ?.click();
        document
            .querySelector(`[${modelFilterAttribute}="${model}"]`)
            ?.click();
    }
    filterIncentivesByCategory(category) {
        const filterElem = this._categoryFilterElements[category];
        if (!filterElem) {
            category = "all";
        }
        if (category === this._selectedCategoryFilter) {
            return;
        }
        for (const header of this._groupHeaders) {
            if (this.isVisibleUnderCategoryFilter(header, category)) {
                header.removeAttribute("hidden");
            }
            else {
                header.setAttribute("hidden", "true");
            }
        }
        for (const block of this._incentiveBlocks) {
            if (this.isVisibleUnderCategoryFilter(block, category)) {
                block.removeAttribute("hidden");
            }
            else {
                block.setAttribute("hidden", "true");
            }
        }
        this._selectedCategoryFilter = category;
        if (this._NewSubaruIncentivesPage) {
            this.updateCategoryHeaderVisibility();
            this.updateNoResultsVisibility();
        }
    }
    filterIncentivesByModel(model) {
        const filterElem = this._modelFilterElements[model];
        if (!filterElem) {
            model = "all";
        }
        if (model === this._selectedModelFilter) {
            return;
        }
        if (model === "all") {
            this.showAllModelElements();
        }
        else {
            this.showElementsForModel(model);
        }
        this._selectedModelFilter = model;
        if (this._NewSubaruIncentivesPage) {
            this.updateCategoryHeaderVisibility();
            this.updateNoResultsVisibility();
        }
    }
    showAllModelElements() {
        for (const header of this._groupHeaders) {
            if (!this.isHiddenByTypeFilter(header) &&
                !this.isHiddenByCategoryFilter(header)) {
                header.removeAttribute("hidden");
            }
        }
        for (const block of this._incentiveBlocks) {
            if (!this.isHiddenByTypeFilter(block) &&
                !this.isHiddenByCategoryFilter(block)) {
                block.removeAttribute("hidden");
            }
        }
    }
    showElementsForModel(model) {
        for (const header of this._groupHeaders) {
            const groupModel = header.getAttribute(incentiveModelAttribute);
            if (groupModel === model &&
                !this.isHiddenByTypeFilter(header) &&
                !this.isHiddenByCategoryFilter(header)) {
                header.removeAttribute("hidden");
            }
            else {
                header.setAttribute("hidden", "true");
            }
        }
        for (const block of this._incentiveBlocks) {
            const blockModel = block.getAttribute(incentiveModelAttribute);
            if (blockModel === model &&
                !this.isHiddenByTypeFilter(block) &&
                !this.isHiddenByCategoryFilter(block)) {
                block.removeAttribute("hidden");
            }
            else {
                block.setAttribute("hidden", "true");
            }
        }
    }
    filterIncentivesByType(type) {
        const filterElem = this._typeFilterElements[type];
        if (!filterElem) {
            type = "all";
        }
        if (type === this._selectedTypeFilter) {
            return;
        }
        if (type === "all") {
            this.showAllTypeElements();
        }
        else {
            this.showElementsForType(type);
        }
        this._selectedTypeFilter = type;
        if (this._NewSubaruIncentivesPage) {
            this.updateCategoryHeaderVisibility();
            this.updateNoResultsVisibility();
        }
    }
    showAllTypeElements() {
        for (const header of this._groupHeaders) {
            if (!this.isHiddenByModelFilter(header) &&
                !this.isHiddenByCategoryFilter(header)) {
                header.removeAttribute("hidden");
            }
        }
        for (const block of this._incentiveBlocks) {
            if (!this.isHiddenByModelFilter(block) &&
                !this.isHiddenByCategoryFilter(block)) {
                block.removeAttribute("hidden");
            }
        }
    }
    showElementsForType(type) {
        for (const header of this._groupHeaders) {
            const groupTypes = header
                .getAttribute(incentiveTypesAttribute)
                .split(" ");
            if (groupTypes.includes(type) &&
                !this.isHiddenByModelFilter(header) &&
                !this.isHiddenByCategoryFilter(header)) {
                header.removeAttribute("hidden");
            }
            else {
                header.setAttribute("hidden", "true");
            }
        }
        for (const block of this._incentiveBlocks) {
            const blockTypes = block.getAttribute(incentiveTypesAttribute).split(" ");
            if (blockTypes.includes(type) &&
                !this.isHiddenByModelFilter(block) &&
                !this.isHiddenByCategoryFilter(block)) {
                block.removeAttribute("hidden");
            }
            else {
                block.setAttribute("hidden", "true");
            }
        }
    }
    updateCategoryHeaderVisibility() {
        for (const header of this._categoryHeaders) {
            const category = header.getAttribute(incentiveCategoryAttribute);
            let hasVisibleBlock = false;
            for (const block of this._incentiveBlocks) {
                if (block.hasAttribute("hidden"))
                    continue;
                const blockCategory = block.getAttribute(incentiveCategoryAttribute);
                if (blockCategory === category) {
                    hasVisibleBlock = true;
                    break;
                }
            }
            if (hasVisibleBlock) {
                header.removeAttribute("hidden");
            }
            else {
                header.setAttribute("hidden", "true");
            }
        }
    }
    updateNoResultsVisibility() {
        const noResults = this._noResultsMessage;
        if (!noResults)
            return;
        const hasVisibleBlock = Array.from(this._incentiveBlocks).some((block) => !block.hasAttribute("hidden"));
        if (hasVisibleBlock) {
            noResults.setAttribute("hidden", "true");
        }
        else {
            noResults.removeAttribute("hidden");
        }
    }
    isVisibleUnderCategoryFilter(elem, category) {
        return (this.elemMatchesCategoryFilter(elem, category) &&
            !this.isHiddenByTypeFilter(elem) &&
            !this.isHiddenByModelFilter(elem));
    }
    elemMatchesCategoryFilter(elem, category) {
        const elemCategory = elem.getAttribute(incentiveCategoryAttribute);
        const elemFuelType = elem.getAttribute(fuelTypeAttribute);
        return (category === "all" ||
            elemCategory === category ||
            elemFuelType === category);
    }
    isHiddenByCategoryFilter(elem) {
        const category = elem.getAttribute(incentiveCategoryAttribute);
        const fuelType = elem.getAttribute(fuelTypeAttribute);
        return (this._selectedCategoryFilter !== "all" &&
            category !== this._selectedCategoryFilter &&
            fuelType !== this._selectedCategoryFilter);
    }
    isHiddenByModelFilter(elem) {
        const model = elem.getAttribute(incentiveModelAttribute);
        return (this._selectedModelFilter !== "all" && model !== this._selectedModelFilter);
    }
    isHiddenByTypeFilter(elem) {
        const types = elem.getAttribute(incentiveTypesAttribute);
        return (this._selectedTypeFilter !== "all" &&
            !types.includes(this._selectedTypeFilter));
    }
    static getFiltersFromUrl() {
        let type = "all";
        let model = "all";
        const hash = window.location.hash;
        const parts = hash.split("&");
        if (parts.length !== 2) {
            return { type, model };
        }
        const typeFilter = decodeURI(parts[0].substring(1)).toLowerCase();
        const modelFilter = decodeURI(parts[1]).toLowerCase();
        type = typeFilter.length > 0 ? typeFilter : "all";
        model =
            modelFilter.length > 0 && modelFilter !== "modelall"
                ? modelFilter
                : "all";
        return { type, model };
    }
}
selfInstantiateOnLoad(ManufacturerIncentives);
